export const MATCHING_ACTIVITY_DRAG_AND_DROP = 2;
export const MATCHING_ACTIVITY_ONE_CLICK = 1;
export const MATCHING_ACTIVITY_TWO_CLICK = 3;
